export default {"src":"/_next/static/media/slider_arrow_right_green.1608e05e.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};